// node_modules
import axios from "axios";
// Enums
import { ReferenceTypeEnum } from "Enums";
// Helpers
import { AxiosHelperSingleton } from "Helpers";
// Types
import { TMagDocumentDTO, TReference, TTechnology, TTechnologyImageDTO, TTechnologyWebLinkDTO, TTechnologyYoutubeVideoDTO, TUsPatentDTO } from "Types";


export class ReferenceController {
    public async getReferencePreviewDataAsync(reference: TReference): Promise<string | TTechnologyImageDTO | TTechnologyYoutubeVideoDTO | undefined> {
        let referencePreviewData: string | TTechnologyImageDTO| undefined = undefined;
        
        try {
            switch (reference.type) {
                case ReferenceTypeEnum.ScienceArticle:
                    const scienceArticle: TMagDocumentDTO = 
                        (await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/articles/mag/${reference.referenceId}`)).data; 
                    referencePreviewData = scienceArticle.title;
                    break;
                case ReferenceTypeEnum.Patent:
                    const patent: TUsPatentDTO = 
                        (await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/articles/patent/${reference.referenceId}`)).data; 
                    referencePreviewData = patent.title;
                    break;
                case ReferenceTypeEnum.InternalLink:
                    if (!reference.technologyId) break;
                    const webPage: TTechnologyWebLinkDTO = 
                        (await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/technologies/${reference.technologyId}/weblinks/${reference.referenceId}`)).data; 
                    referencePreviewData = webPage.title;
                    break;
                case ReferenceTypeEnum.Technology:
                    const technology: TTechnology =  
                        (await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/technologies/${reference.referenceId}/description`)).data; 
                    referencePreviewData = technology.name;
                    break;
                case ReferenceTypeEnum.Image:
                    if (!reference.technologyId) break;
                    const image: TTechnologyImageDTO = 
                        (await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/technologies/${reference.technologyId}/medias/savedimages/${reference.referenceId}`)).data; 
                    referencePreviewData = image;
                    break;
                case ReferenceTypeEnum.YoutubeVideo:
                    if (!reference.technologyId) break;
                    const youtubeVideo: TTechnologyYoutubeVideoDTO = 
                        (await axios.get<TTechnologyYoutubeVideoDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/technologies/${reference.technologyId}/medias/youtubevideos/${reference.referenceId}`)).data; 
                    referencePreviewData = youtubeVideo;
                    break;
                default:
                    referencePreviewData = undefined;
                    break;
            }
        } catch (error) {
            referencePreviewData = undefined;
        }

        return referencePreviewData;
    }
}

export const ReferenceControllerSingleton = new ReferenceController();